document.addEventListener("DOMContentLoaded", e => {
    setTimeout(() => {
      const option = document.getElementById("option1");
        option.addEventListener("change", e => {
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
            }, 1000);
        }, true);
    }, 1000);

    if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
        setTimeout(() => {
            const observer = new MutationObserver((MutationList) => {
                for (let item of MutationList) {
                    if (item.target.classList?.contains('quick-search__results')) {
                        window.dispatchEvent(new Event("scroll"));
                    } else if (item.target.classList?.contains('animation--item')) {
                        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                    }
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }, 300);
    }
});